import { userConstants } from "../../../constants/user.constants";

export function account(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ACCOUNT_DETAILS_REQUEST:
      return {
        loading: true
      };
    case userConstants.GET_ACCOUNT_DETAILS_SUCCESS:
      return {...state,
        loading:false, 
        user: action.user
      };
    case userConstants.GET_ACCOUNT_DETAILS_FAILURE:
      return {
        ...state,
        loading:false, 
        error: action.error
      };
      case userConstants.UPDATE_REQUEST:
      return {...state,
        loading: true,
        saved:false,
        user: action.user
      };
    case userConstants.UPDATE_SUCCESS:
      return {...state,
        loading: false,
        saved:true,
      };
    case userConstants.UPDATE_FAILURE:
      return {...state,
        loading: false,
        saved:false,
        error: action.error
      };
    
    default:
      return state;
  }
}
